import api from './api';
import { Plan, AssociatePlan, PlanFormData, ApiResponse, AssociatePlanLog, PlanLog } from '../types';

export const planService = {
  async getAll(): Promise<Plan[]> {
    const response = await api.get<Plan[]>('/plans');
    return response.data;
  },

  async getById(id: number): Promise<Plan> {
    const response = await api.get<Plan>(`/plans/${id}`);
    return response.data;
  },

  async create(data: PlanFormData): Promise<ApiResponse<Plan>> {
    const response = await api.post<ApiResponse<Plan>>('/plans', data);
    return response.data;
  },

  async update(id: number, data: PlanFormData): Promise<ApiResponse<Plan>> {
    const response = await api.put<ApiResponse<Plan>>(`/plans/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(`/plans/${id}`);
    return response.data;
  },

  async toggleStatus(id: number): Promise<ApiResponse<Plan>> {
    const response = await api.patch<ApiResponse<Plan>>(`/plans/${id}/toggle-status`);
    return response.data;
  },

  // Buscar planos de um associado específico
  async getAssociatePlans(associateId: number): Promise<AssociatePlan[]> {
    const response = await api.get<AssociatePlan[]>(`/associates/${associateId}/plans`);
    return response.data;
  },

  // Buscar logs de alterações de um plano de associado
  async getPlanLogs(associateId: number, planId: number): Promise<AssociatePlanLog[]> {
    const response = await api.get<AssociatePlanLog[]>(`/associates/${associateId}/plans/${planId}/logs`);
    return response.data;
  },

  // Buscar histórico de logs de um plano
  async getLogs(planId: number): Promise<PlanLog[]> {
    const response = await api.get<PlanLog[]>(`/plans/${planId}/logs`);
    return response.data;
  }
};
